<template>
  <router-view v-if="!pageLoading" />
  <Splash v-if="pageLoading" />
  <notifications
    animation-type="css"
    :class="{
       'lcu-notification-ios': _device.iPhone && _device.app,
      }"
    :speed="500"
    position="bottom right" />
</template>

<script>
import { mapGetters } from 'vuex';
import { CognitoUserPool } from 'amazon-cognito-identity-js';
import { Device } from '@capacitor/device';
import Splash from '@/global-view/splash/Splash.vue';
import Auth from '@/mixins/Auth.vue';
import { NO_ENROLL_FEE, NOTIFICATION_ERROR } from '@/globals/constants';

export default {
  name: 'lcu-app',
  mixins: [Auth],
  computed: {
    ...mapGetters(['user']),
  },
  components: {
    Splash,
  },
  data() {
    return {
      pageLoading: false,
      loadedData: {
        user: false,
      },
    };
  },
  created() {
    const userPool = new CognitoUserPool({
      UserPoolId: process.env.VUE_APP_USERPOOL_ID,
      ClientId: process.env.VUE_APP_CLIENT_ID,
    });
    this.$store.dispatch('setUserPool', userPool);
    this.getDevice();
  },
  watch: {
    loadedData: {
      handler({ user }) {
        if (user) {
          this.checkRequestedRoute();
        }
      },
      deep: true,
    },
    $route: {
      handler() {
        if (!this.user.id) {
          this.checkSession();
        }
      },
      deep: true,
    },
  },
  methods: {
    async getDevice() {
      const info = await Device.getInfo();
      this.$store.dispatch('setDeviceInfo', info);
    },
    async checkSession() {
      try {
        this.pageLoading = true;
        const isAuthRoute = this.$router.currentRoute.value?.meta?.auth;
        if (!isAuthRoute) {
          // if it's not an auth route, we can check session without awaiting and blocking page load
          this.$validateSession({ skipRedirect: true }).then((session) => {
            if (session) {
              this.loadUserData();
            }
          });
        } else {
        // if it's an auth route, we need to await session validation before routing to ensure
        // user data is loaded for the page they are trying to access
          const session = await this.$validateSession({ skipRedirect: true });
          if (session) {
            await this.loadUserData();
          }
          if (!session) {
            this.$router.push('/iniciar-sesion');
          }
        }
      } catch (e) {
        const message = e.message || e;
        this.$log.error(message);
      } finally {
        this.pageLoading = false;
      }
    },
    async loadUserData() {
      try {
        this.$store.dispatch('setUserLoading', { value: true });
        const { user } = await this.$students({ method: 'getUserData' });
        this.$store.dispatch('setUser', { user });
        this.loadedData.user = true;
        this.$log.info('user set: ', user);
        if (user?.fees?.enrollment === 'unpaid') {
          // TODO: pass link option, then need a cart page for the fee
          this.$store.dispatch('addGlobalAnnouncement', {
            text: NO_ENROLL_FEE,
            type: 'warn',
          });
        }
      } catch (e) {
        const message = e.message || e;
        this.$log.error(message);
        this.$notify({
          title: NOTIFICATION_ERROR,
          text: message,
          type: 'error',
          duration: -1,
        });
      } finally {
        this.$store.dispatch('setUserLoading', { value: false });
      }
    },
    checkRequestedRoute() {
      const requestedRoute = window.localStorage.getItem('lcuRequestedPath');
      if (requestedRoute && requestedRoute !== '/') {
        this.$router.push(requestedRoute);
        localStorage.removeItem('lcuRequestedPath');
      }
    },
  },
};
</script>

<style scoped lang="scss">
  .lcu-notification-ios {
    bottom: 80px !important;
  }
</style>
